import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
      options: {
        customProperties: true,
      },
    themes: {
      light: {
        header:'#426fbe', //azul header
        primary: '#82A1D0', //celeste tablas
        secondary: '#E7E7E7', // gris claro
        accent: '#909DFA', // lavanda
        error: '#FF8D58', // naranja
        info: '#39537a', //celeste claro
        success: '#718294', // gris oscuro
        warning: '#FF8D58' // amarillo
      },
    },
  },
  icons: {
    iconfont: 'fa',
  },
});